module.exports = __webpack_public_path__ + "static/fonts/Roboto300italic.afd48b81.ttf";